<template>
    <div class="home-page">
		<Header></Header>
		<div class="list" v-if="!notFound">
			<div class="nav flex">
				<div class="back" @click="back">
					<img src="static/images/return.png" />
				</div>
			</div>
      <div class="ac">
        <img class="img1" src="../../static/images/qs.png" />
      </div>
			<div class="section-list mt100">
        <div class="fs50 fw7">{{title}}</div>
        <div class="list-content">
          <div class="tips mt10 ml10">{{$t('homeTips2')}}</div>
          <div class="list-c mt50 flex">
            <div class="list-li" :class="{'active':isShow==item.id}" v-for="(item,index) in list" @click="getSelect(item.id,item.name)">
              <img :src="item.image">
              <div class="li-title ac">
                <div>
                  <div>{{item.name}}</div>
                  <div class="fs22">{{item.desc}}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
			</div>
			<div class="mt100">
				<button class="btn active fs40" @click="buyAnswer(1)">
					{{$t('Next')}}
				</button>
				<button class="btn fs40" @click="back">
					{{$t('Back')}}
				</button>
			</div>
			<Dialog ref="saveDialog2" :callback="tips2Modal" title="" type="alert" :btnText="$t('Yes')" cancelText="">
				<div slot="mdBox" >
					<div class="ac fs33">
						<div class="radio-div">
							{{$t('tips2')}}
						</div>
					</div>
				</div>
			</Dialog>
		</div>
	</div>
</template>
<script>
import Header from '../components/HeaderNoLogo'
import Dialog from '../components/dialog'
export default {
  components:{
    Header,
    Dialog
  },
  data() {
    return {
      notFound:false,
      list:[],
      modalFoot:false,
      isShow:'',
      lang:'en',
      title:'',
      name:''
    }
  },
  mounted() {
		let that = this;
  },
	created(){
    this.title = this.$route.query.name
		this.getHome();
	},
  methods: {
    getSelect(id,name){
      this.isShow = id
      this.name = name
    },
		back(){
			this.$router.push({path:'/'})
		},
		getHome(){
			let that =this;
			that.$parent.loadModal(true);
			let data = {
        subject_id:this.$route.query.id
			}
			that.$api.post('/api/index/chapter',data,r =>{
				that.$parent.returnCode(r,function(){
					that.list = r.data
					that.$parent.loadModal(false);
			  });

			})
		},
		tips2Modal(){
			this.$refs.saveDialog2.closeMask();
		},
		//购买
		buyAnswer(id,name){
			let that =this;
      if(!that.isShow){
        this.$utils.alertText(that.$t('pleaseSelect'),80);
        return
      }
			this.$router.push({path:'/contentList',query: {id:this.isShow,title:this.$route.query.name,name:this.name}})
		},
	}
}
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/page/list.vue